import * as React from "react";
import * as _ from "lodash";
import {
  ICalendarPageListProps,
  ICalendarPageListState,
  CalenderItem,
} from "./CalendarPageList.types";
import { ToggleBox } from "../ToggleBox/ToggleBox";
import { Icon } from "../Icon/icon";

export class CalendarPageList extends React.Component<
  ICalendarPageListProps,
  ICalendarPageListState
> {
  private searchField: HTMLInputElement;

  constructor(props: ICalendarPageListProps) {
    super(props);
    this.state = {
      calenderItemList: this.props.calenderItemList,
      itemChecked: {},
      limit: 9,
      checkedClass: "",
      LoadMoreHidden: false,
    };
  }

  //Filters
  checkItem = (e: React.ChangeEvent<HTMLInputElement>) => {
    const itemChecked = this.state.itemChecked;

    const value = e.currentTarget.value;
    const checked = e.currentTarget.checked;

    const newState = JSON.parse(JSON.stringify(itemChecked));
    newState[value] = checked;

    this.setState({
      itemChecked: _.mapKeys(newState, (value, key) => {
        return key;
      }),
    });
  };

  componentDidMount() {
    this.hideLoadMore();
  }
  componentDidUpdate(prevProps, prevState) {
    this.setFocus(prevState.limit);
  }

  //Render the filtered list, render in sections (9st) at a time.
  renderCalenderList = () => {
    const items = this.state.calenderItemList;
    let itemChecked = this.state.itemChecked;

    return items
      .filter((item) => {
        if (this.nothingChecked()) {
          return true;
        }

        if (item.TagList.length === 0) {
          return false;
        }

        return item.TagList.some((cat) => {
          let itemFound = this.itemIsFound(itemChecked, cat);
          return !!itemFound;
        });
      })
      .slice(0, this.state.limit)
      .map(this.renderCalenderItem);
  };

  //If Item is Found return the filtered list
  itemIsFound = (itemChecked, cat: string) => {
    var found = false;
    Object.keys(itemChecked).find((key) => {
      if (key === cat) {
        var valueIsTrue = itemChecked[key];
        if (valueIsTrue) {
          return (found = true);
        } else {
          return (found = false);
        }
      } else {
        return (found = false);
      }
    });
    return found;
  };

  //If no filter is clicked
  nothingChecked = () => {
    const itemChecked = this.state.itemChecked;
    for (let k in itemChecked) {
      if (itemChecked.hasOwnProperty(k) && itemChecked[k]) {
        return false;
      }
    }
    return true;
  };

  hideLoadMore = () => {
    var limitCount = this.state.limit;
    var totalItems = this.props.calenderItemList.length;
    var diffrence = totalItems - limitCount;
    if (diffrence > 0) {
      return this.setState({
        LoadMoreHidden: true,
      });
    } else {
      return this.setState({
        LoadMoreHidden: false,
      });
    }
  };

  //Load more
  onLoadMore = () => {
    this.setState({
      limit: this.state.limit + 9,
    });

    this.hideLoadMore();
  };
  setFocus = (limit: number) => {
    var contentList = document.querySelectorAll(".contentlist-link");
    if (contentList.length > 0) {
      var item = contentList[limit] as HTMLAnchorElement;
      if (item) {
        item.focus();
      }
    }
  };

  renderCheckbox = () => {
    return (
      <fieldset>
        <div className="page-list__filters">
          {this.props.categoryListFilter.map((category, i) => {
            <legend className="sr-only">Kategorier</legend>;
            return (
              <ToggleBox
                key={`calendarfilterbox-${i}`}
                label={category}
                value={category}
                onChangeCb={this.checkItem}
              />
            );
          })}
        </div>
      </fieldset>
    );
  };

  renderCalenderItem = (item: CalenderItem, index: number): JSX.Element => {
    return (
      <div
        key={index}
        className="col-sm-12 col-md-4  calendar-pagelist__current-calendar"
      >
        <div className="current-calendar">
          <a
            href={item.Url}
            className="current-calendar__container contentlist-link"
          >
            <article>
              <time dateTime={item.AttributeDate}>
                {item.SpanDate} {item.Startdate}
              </time>
              <div className="current-calendar__time-border" />
              <h2>{item.Headline}</h2>
              <div className="current-calendar__footer">
                <div className="current-calendar__tag-list">
                  {" "}
                  {item.TagList.map((tag) => (
                    <div
                      key={tag}
                      className="current-calendar__tag-item text-micro"
                    >
                      {tag}
                    </div>
                  ))}
                </div>

                <div className="calendar-pagelist__address-container current-calendar__address-container">
                  <Icon
                    iconType="fontawesome/map-marker-alt-solid"
                    isAriaHidden={false}
                    ariaLabel="Adress"
                  />
                  <div className="current-calendar__address text-micro">
                    {item.Address}
                  </div>
                </div>
              </div>
            </article>
          </a>
        </div>
      </div>
    );
  };

  searchSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    var searchTerm = this.searchField.value;
    var filteredItems = this.props.calenderItemList.filter((item) => {
      return item.Headline.toLowerCase().indexOf(searchTerm) !== -1;
    });

    return this.setState({
      calenderItemList: filteredItems,
    });
  };

  render(): JSX.Element {
    const { calenderItemList, searchId } = this.props;
    const { LoadMoreHidden, limit } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-lg-6">
            <form
              onSubmit={this.searchSubmit}
              role="search"
              aria-label="Sök inom kalendariet"
            >
              <span className="search">
                <label htmlFor={searchId} className="sr-only">
                  Ange söktext
                </label>
                <input
                  id={searchId}
                  onChange={this.searchSubmit}
                  type="search"
                  ref={(ref) => (this.searchField = ref)}
                  placeholder="Sök"
                />
                <input
                  aria-label="Sök"
                  className="search__button"
                  type="submit"
                  value=""
                />
              </span>
            </form>
          </div>
          <div className="col-lg-12">{this.renderCheckbox()}</div>
        </div>
        <div className="row" role="log" aria-atomic="false">
          {this.renderCalenderList()}
        </div>

        {LoadMoreHidden && calenderItemList.length > limit && (
          <button className="page-list__load-more" onClick={this.onLoadMore}>
            Ladda mer ({calenderItemList.length - limit} kvar)
          </button>
        )}
        <div className="sectionfooter" />
      </div>
    );
  }
}
